import { SyntheticEvent, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router';
import { useSetAtom } from 'jotai';
import { userAtom, userLoginModalOpenAtom } from '../atoms/userAtom';
import { requestEmailCode, requestSigninByEmailCode } from '../utils/api';

enum LoginStep {
  Email = 1,
  Code = 2
}

function LoginModal() {
  const [step, setStep] = useState(LoginStep.Email);
  const [email, setEmail] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const setUser = useSetAtom(userAtom);
  const setUserLoginModalOpen = useSetAtom(userLoginModalOpenAtom);

  const sendEmailCode = async () => {
    setLoading(true);
    const success = await requestEmailCode(email);
    if (success) {
      setStep(LoginStep.Code);
      setValidated(false);
    }

    setLoading(false);
  };

  const signinByCode = async () => {
    setLoading(true);
    const user = await requestSigninByEmailCode(email, code);
    setUser(user);
    setLoading(false);
  };

  const handleSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    if (form.checkValidity()) {
      switch (step) {
        case LoginStep.Email:
          sendEmailCode();
          break;
        case LoginStep.Code:
          signinByCode();
          break;
      }
    }

    setValidated(true);
  };

  return (
    <Modal show={true} backdrop="static" keyboard={false} centered={true}>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Sign in by email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {step === LoginStep.Email && (
            <Form.Group className="mb-3">
              <Form.Label>For new and registered users</Form.Label>
              <Form.Control
                disabled={loading}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                name="email"
                placeholder="Email"
                required
                autoFocus
              />
            </Form.Group>
          )}
          {step === LoginStep.Code && (
            <Form.Group className="mb-3">
              <Form.Label>
                We sent a verification code
                <br />
                to {email}
              </Form.Label>
              <Form.Control
                disabled={loading}
                value={code}
                onChange={(event) => setCode(event.target.value.slice(0, 6))}
                type="number"
                placeholder="Enter the code"
                min={100000}
                max={999999}
                maxLength={6}
                required
                autoFocus
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Link to="/" style={{ textDecoration: 'none' }} onClick={() => setUserLoginModalOpen(false)}>
            Back to home screen
          </Link>
          <Button
            size="lg"
            variant="primary"
            type="submit"
            disabled={loading}
            className="ms-auto"
          >Next &#8640;</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default LoginModal;
